import { useEffect, useState } from 'react';
import { useTheme } from '@emotion/react';
import { http } from '../../lib/api/http';
import { V2 } from '../../lib/api/urls';
import { ConfigTypes } from '../../models/config';
import {
  DEVICE_SCREENS,
  DEVICE_SCREENS_MAX_STRING,
  YaLinkToAppStores,
} from '../../lib/consts';
import MobileAppSVG from '../../public/img/mobile-app.svg';
import { useSeoAnalytics } from '../../providers/seo-analytics';

export function OfferToInstallMobileApplicationModal() {
  const [showPopUp, setShowPopUp] = useState(false);
  const seoAnalytics = useSeoAnalytics();
  const theme = useTheme();

  useEffect(() => {
    const userWantsToStayOnSite =
      Number(localStorage.getItem('user-want-to-stay')) === 1;
    if (!userWantsToStayOnSite && window.innerWidth <= DEVICE_SCREENS.lg) {
      http.get(V2.config, {}).then((config: ConfigTypes) => {
        const isShowPoupFromConfig = !!config.find(
          (item) => item.name === 'SHOW_MOBILE_APP_POPUP'
        )?.value;
        if (isShowPoupFromConfig) {
          setShowPopUp(true);
        }
      });
    }
  }, []);

  const onUserWantToStay = () => {
    localStorage.setItem('user-want-to-stay', String(1));
    setShowPopUp(false);
  };

  const onUserGoToStore = () => {
    setShowPopUp(false);
    if (seoAnalytics.dispatch) {
      seoAnalytics.dispatch({ ym: ['Click_app_popup'] });
    }
    window.location.href = YaLinkToAppStores;
  };

  return showPopUp ? (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100dvh',
        background: 'rgba(0, 0, 0, 0.50)',
        zIndex: 10001,
      }}
    >
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          gap: 24,
          background: theme.colors.white,
          padding: '28px 20px 16px 20px',
          borderRadius: '20px 20px 0 0',
        }}
      >
        <div
          css={{
            display: 'flex',
            gap: 16,
          }}
        >
          <div>
            <MobileAppSVG />
          </div>
          <div>
            <p
              css={{
                marginTop: 6,
                color: '#121212',
                fontFamily: 'Inter',
                fontSize: 20,
                fontWeight: 600,
                '@media(max-width: 380px)': {
                  fontSize: 18,
                  marginBottom: 6,
                },
              }}
            >
              В приложении ещё лучше
            </p>
            <p
              css={{
                color: 'rgba(18, 18, 18, 0.60)',
                fontFamily: 'Inter',
                fontSize: 14,
                fontWeight: 400,
              }}
            >
              Выберите, где хотите продолжить
            </p>
          </div>
        </div>
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
          }}
        >
          <button
            type='button'
            onClick={onUserGoToStore}
            css={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: 48,
              background: theme.colors.primary,
              color: theme.colors.white,
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: 16,
              fontWeight: 500,
              letterSpacing: '-0.32px',
              borderRadius: '24px',
            }}
          >
            <p>Перейти в приложение</p>
          </button>
          <button
            onClick={onUserWantToStay}
            type='button'
            css={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: 48,
              background: theme.colors.buttonSecondary,
              color: '#121212',
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: 16,
              fontWeight: 500,
              letterSpacing: '-0.32px',
              borderRadius: '24px',
            }}
          >
            Остаться на сайте
          </button>
        </div>
      </div>
    </div>
  ) : null;
}
